import VideoCard from "../Cards/VideoCard";
import React, { useEffect, useState } from "react";
import { ConferenceContext } from "../../index";
import clsx from "clsx";
import { useAppSelector } from "../../../../app/hooks";

function calculateLayout(
  containerWidth: number,
  containerHeight: number,
  videoCount: number,
  aspectRatio: number
) {
  let bestLayout = {
    area: 0,
    cols: 0,
    rows: 0,
    width: 0,
    height: 0,
  };

  // brute-force search layout where video occupy the largest area of the container
  for (let cols = 1; cols <= videoCount; cols++) {
    const rows = Math.ceil(videoCount / cols);
    const hScale = containerWidth / (cols * aspectRatio);
    const vScale = containerHeight / rows;
    let width;
    let height;
    if (hScale <= vScale) {
      width = Math.floor(containerWidth / cols);
      height = Math.floor(width / aspectRatio);
    } else {
      height = Math.floor(containerHeight / rows);
      width = Math.floor(height * aspectRatio);
    }
    const area = width * height;
    if (area > bestLayout.area) {
      bestLayout = {
        area,
        width,
        height,
        rows,
        cols,
      };
    }
  }

  return bestLayout;
}

const LayoutTiled = (props: any) => {
  const conference = React.useContext(ConferenceContext);
  const { vCallIncomingMessage, vCallState } = useAppSelector(
    (state) => state.vcall
  );
  conference.updateMaxVideoTrackCount(conference.globals.desiredMaxVideoTrackCount);

  const aspectRatio = 16 / 9;
  const [cardWidth, setCardWidth] = React.useState(500 * aspectRatio);
  const [cardHeight, setCardHeight] = React.useState(500);
  const [agentHasMeetParticipant, setAgentHasMeetparticipant] = useState(false)
  React.useEffect(() => {

    const videoCount = (conference.videoTrackAssignments as any[]).filter((x: any) => x.videoLabel !== conference.publishStreamId).length

    const { width, height } = calculateLayout(
      props.width,
      props.height,
      videoCount,
      aspectRatio
    );

    setCardWidth(width);
    setCardHeight(height);

    //console.log("***** W:"+cardWidth+" H:"+cardHeight+" props.width:"+props.width+" width:"+width+" cols:"+cols+" vc:"+videoCount);
  }, [conference.videoTrackAssignments, props.width, props.height, conference.participantUpdated]);

  const showOthers = Object.keys(conference.allParticipants).length > conference.globals.maxVideoTrackCount;

  //if we need to show others card, then we don't show the last video to hold place for the others card
  const realPlayingParticipants = conference.videoTrackAssignments

  const videoCards = () => {

    return (
      <div className="flex flex-wrap gap-3 md:gap-5 justify-center items-center w-full h-fit px-5 py-12 overflow-y-scroll md:overflow-hidden">
        {

          realPlayingParticipants.map((element: any, index: number) => {
            // eslint-disable-next-line
            let isPlayOnly
            try {
              isPlayOnly = JSON.parse(conference?.allParticipants[element?.streamId]?.metaData)?.isPlayOnly;
            } catch (e) {
              isPlayOnly = false;
            }
            if (element?.videoLabel == conference.publishStreamId)
              return <></>

            const strId = element?.streamId == conference.roomName ? element.videoLabel : element.streamId
            const participantName = conference?.allParticipants[strId]?.name;
            if (participantName === "" || typeof participantName === 'undefined' || isPlayOnly || participantName === "Anonymous") {
              return null;
            }

            if (vCallIncomingMessage.channel == "audio" && participantName == "You")
              return <></>

            const audioTrack = conference.audioTracks.filter((x: any) => x.id.replace("audio", "") == element?.videoLabel?.replace("video", ""))

            //console.log("cw:"+cardWidth+" ch:"+cardHeight);
            return (
              <div
                className={clsx("single-video-container not-pinned  m-0 p-0 box-border", { "w-[200px] h-[200px]": !props.isFullScreen }, { "w-fit h-fit": props.isFullScreen })}
                key={index}
                style={{
                  // width: `${cardWidth}px`,
                  // height: `${cardHeight}px`,
                }}
              >
                <VideoCard
                  trackAssignment={element}
                  audioTrackAssignment={audioTrack}
                  autoPlay
                  name={participantName}
                  onHandlePin={() => {
                    if (vCallIncomingMessage.channel !== "audio")
                      conference.pinVideo(element.streamId);
                  }}
                  id={`${participantName}`}
                  isTiled
                />
              </div>
            )
          })
        }
      </div>
    );
  }

  const othersCard = () => {
    return (
      <>
        {showOthers ? (
          <div
            className="single-video-container not-pinned others-tile-wrapper"
            style={{
              width: `${cardWidth}px`,
              height: `${cardHeight}px`,
              maxWidth: `${cardWidth}px`,
            }}
          >
            {/* <OthersCard
                  playingParticipants = {playingParticipants}
                /> */}
          </div>
        ) : null
        }
      </>
    );
  }
  useEffect(() => {
    const participantLength = Object.keys(conference.allParticipants)?.length;
    if (participantLength == 1 && !agentHasMeetParticipant) {
      console.log('enter left Participant event', participantLength)
      props.onLeftParticipant();
      conference.setOnLeftParticipant(true);
    } else if (participantLength > 1) {
      setAgentHasMeetparticipant(true);
    }
  }, [Object.keys(conference.allParticipants)])
  return (
    <>
      {/* {conference?.videoTrackAssignments.length === 0 ? <p>There is no active publisher right now.</p> : null} */}
      {videoCards()}
      {process.env.REACT_APP_LAYOUT_OTHERS_CARD_VISIBILITY === 'true' ? othersCard() : null}
    </>
  )
};

export default LayoutTiled;
